import { memo, ReactElement, ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'

import {
  StatusCardWrapper,
  StatusCardHeader,
  StatusCardHeaderWrapper,
  StatusCardBody,
} from './styles'

interface StatusCardProps {
  loading?: boolean
  title: string | ReactNode
  icon: ReactElement
  status: string
  children?: ReactNode
}

function StatusCard({
  loading,
  title,
  icon,
  status,
  children,
}: StatusCardProps) {
  if (loading) {
    return <Skeleton height={'100%'} borderRadius={8} />
  }
  return (
    <StatusCardWrapper status={status}>
      <StatusCardHeaderWrapper>
        <StatusCardHeader>
          {icon}
          {title}
        </StatusCardHeader>
      </StatusCardHeaderWrapper>

      <StatusCardBody>{children}</StatusCardBody>
    </StatusCardWrapper>
  )
}

export default memo(StatusCard)
